import gql from 'graphql-tag';

export default gql`
  mutation deletePermissionPreset($id: Int!) {
    deletePermissionPreset(id: $id)
  }
`;
